

























import { createComponent } from '@vue/composition-api';

import { useI18n } from '@/core/i18n';

import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';

export default createComponent({
  components: {
    UIButton,
  },
  setup () {
    return {};
  },
});
